import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { RestApiBase } from '../shared/configurations/rest-api-base.config';
import { UrlUtils } from '../shared/utils/url.utils';
import { EsploroPersonPortalFieldTypes } from '../shared/interfaces/profile-activation.interface';
import { JwtUtilService } from '../core/jwt-util.service';

@Injectable({
    providedIn: 'root',
})
export class ProfileActivationService {
    private http = inject(HttpClient);
    private jwtUtilService = inject(JwtUtilService);

    _institutionCode: string;

    constructor() {
        this._institutionCode = UrlUtils.getParam('institution');

    }

    getResearchActivationStatus() {
        const params = new HttpParams()
            .set('institution', this._institutionCode)
            .set('userID', this.jwtUtilService.getUserID());
        return this.http.get(RestApiBase.GET_RESEARCH_ACTIVATION_STATUS, { params: params });
    }

    setResearchActivationStatus(status: EsploroPersonPortalFieldTypes) {
        let params = new HttpParams();
        params = params.set('institution', this._institutionCode)
            .set('userID', this.jwtUtilService.getUserID());
        const body = {
            'portalField': status,
        };
        return this.http.post(RestApiBase.SET_RESEARCH_ACTIVATION_STATUS, body, { params: params });
    }

}
